import 'reflect-metadata';
import { mainContainer } from './inversify.config';
import { bootstrap } from './contextManager';

bootstrap(mainContainer);

export * from './contextManager';
